import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, withKeys as _withKeys, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "pc-token inner-box" }
const _hoisted_2 = { class: "token-table table-shadow" }
const _hoisted_3 = { class: "head flex-between" }
const _hoisted_4 = { class: "token-count" }
const _hoisted_5 = { class: "search-wrap flex-left" }
const _hoisted_6 = { class: "search-symbol-item flex-left" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "light" }
const _hoisted_10 = { class: "introduce" }
const _hoisted_11 = { class: "bottom-page flex-right" }

import Bread from "@/components/computer/Breadcrumb.vue";
import PageContainer from "@/components/computer/PageContainer.vue";
import { filterNum, formatTime } from "@/utils/filters";
import useTokenList from "@/mixins/tokenList";
import type { TokenTableRow } from "@/mixins/tokenList";


export default /*@__PURE__*/_defineComponent({
  __name: 'Token',
  setup(__props) {

const {
    coinSearch,
    pages,
    Tokens,
    loading,
    searchMode,
    searchTableLoading,
    searchToken,
    querySearch,
    pageChange,
    sizeChange,
    goTokenDetail,
    selectSearchSuggestion,
} = useTokenList();

function onRowClick(row: TokenTableRow): void {
    goTokenDetail(row);
}

function tokenTime(raw: string | number | undefined): string {
    if (raw == null || raw === "") return "-";
    const t =
        typeof raw === "number"
            ? raw
            : /^\d+$/.test(String(raw))
                ? Number(raw)
                : new Date(String(raw)).getTime();
    if (Number.isNaN(t)) return "-";
    return String(formatTime(t));
}

return (_ctx: any,_cache: any) => {
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Bread, { backTitle: "Token (ERC-20)" }),
    _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "section-title" }, "代币列表", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          (_unref(searchMode))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("共检索到 " + _toDisplayString(_unref(Tokens).length) + " 条", 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("总共 " + _toDisplayString(_unref(filterNum)(_unref(pages).total) || 0) + " 种 token 代币", 1)
              ], 64))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_autocomplete, {
            modelValue: _unref(coinSearch),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(coinSearch) ? (coinSearch).value = $event : null)),
            class: "search-input",
            "fetch-suggestions": _unref(querySearch),
            clearable: "",
            placeholder: "请输入币种名称",
            "trigger-on-focus": false,
            onSelect: _unref(selectSearchSuggestion),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_unref(searchToken)(_unref(coinSearch))), ["enter"]))
          }, {
            default: _withCtx(({ item }) => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: item.icon,
                  alt: ""
                }, null, 8, _hoisted_7),
                _createElementVNode("span", null, _toDisplayString(item.value || item.symbol), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "fetch-suggestions", "onSelect"])
        ])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: _unref(Tokens),
        stripe: "",
        style: {"width":"100%"},
        class: "data-table",
        "empty-text": "暂无数据",
        "element-loading-text": "拼命加载中...",
        "element-loading-spinner": "el-icon-loading",
        "element-loading-background": "rgba(255, 255, 255, 0.8)",
        onRowClick: onRowClick
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "index",
            label: "编号",
            width: "130"
          }),
          _createVNode(_component_el_table_column, {
            label: "代币",
            width: "200"
          }, {
            default: _withCtx((item) => [
              _createVNode(_component_router_link, {
                class: "flex-left token-box",
                to: `/tokenDetail?tokenAdr=${item.row.address}`,
                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: item.row.icon,
                    class: "token-icon",
                    alt: ""
                  }, null, 8, _hoisted_8),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(item.row.symbol), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "简介",
            "min-width": "280"
          }, {
            default: _withCtx((item) => [
              _createElementVNode("pre", _hoisted_10, _toDisplayString(item.row.name || item.row.introduce || "-"), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "时间",
            width: "200",
            align: "center"
          }, {
            default: _withCtx((item) => [
              _createElementVNode("span", null, _toDisplayString(tokenTime(item.row.deploy_time)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, _unref(loading) || _unref(searchTableLoading)]
      ]),
      _createElementVNode("div", _hoisted_11, [
        (!_unref(searchMode))
          ? (_openBlock(), _createBlock(PageContainer, {
              key: 0,
              onPageChange: _unref(pageChange),
              onSizeChange: _unref(sizeChange),
              currentPage: _unref(pages).currentPage,
              pageSize: _unref(pages).pageSize,
              total: _unref(pages).total
            }, null, 8, ["onPageChange", "onSizeChange", "currentPage", "pageSize", "total"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})